import React from "react";

import { formatDDMMYYYYbyYYYYMMDD, userDropdownLabel } from "app/_helpers/helper";
import { DDMMYYYYFormat } from "app/_helpers/dateHelper";

const obj = {
  ro: "Reporting Officer",
  so: "Safety Officer",
  mm: "Mines Manager",
  investigator: "Investigator",
  vto: "VTO",
  scheduler: "Scheduler",
  approver: "Approver",
  reviewer: "Reviewer",
  "Vfl Officer": "Vfl Officer",
};

const otherDataKey = {
  so_recommended_investigation: "Investigation Recommended",
  investigatorSeverityPostReview: "Suggested Severity",

  review: "Comment",
  reviewCompletionSummary: "Comment",
  investigationCompletionSummary: "Comment",
};

const ViewComments = ({ comments, title, hideTitle, hideNotApplicable }) => (
  <div className="card p-3 pb-0 mt-2 EHS_module_create_form">
    {!hideTitle && (
      <div className="simple-card-title">
        <h3 class="text-capitalize mb-0">{title || "Reviewer Inputs"}</h3>
      </div>
    )}

    <div className="ehsFormWrapper pb-2">
      {comments && comments.length ? (
        <div className="w-100">
          <div>
            <div className="chatsection">
              {comments.map((data, index) => (
                <div key={index} className="chatscreen">
                  <h5>
                    <span>{obj[data.userRoleLabel]} - </span>

                    <span className="chatname">
                      {userDropdownLabel(data.reviewer)}&nbsp;
                    </span>

                    <span className="chattime">
                      {" "}
                      &nbsp;{formatDDMMYYYYbyYYYYMMDD(data.createdAt)}
                    </span>
                  </h5>

                  {data?.reviewDate && (
                    <p className="mb-0">Review Date: {DDMMYYYYFormat(data.reviewDate)}</p>
                  )}

                  {data?.otherData ? (
                    <span>
                      {Object.keys(otherDataKey).map((d) => {
                        return (
                          <>
                            {data?.otherData[d] ? (
                              <>
                                {d === "so_recommended_investigation" ? (
                                  <span>
                                    {otherDataKey[d]}: {data?.otherData[d] ? "YES" : "NO"}
                                  </span>
                                ) : (
                                  <span>
                                    {otherDataKey[d]}: {data?.otherData[d]}
                                  </span>
                                )}
                                <br />
                              </>
                            ) : (
                              ""
                            )}
                          </>
                        );
                      })}
                    </span>
                  ) : (
                    <p className="mb-0">Comment: {data?.review}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      ) : (
        !hideNotApplicable && <p class="text-danger">Not Applicable</p>
      )}
    </div>
  </div>
);

export default ViewComments;
